import { BrandManagementRequest } from "models/brand-management"
import * as Yup from "yup"

export class BrandAdvancedSearchForm
{
	brand: string|null = null
	company: string|null = null
	products: string[]|null = []
	contracts09: boolean|null = null
	contracts1099: boolean|null = null
	contracts100999: boolean|null = null
	contracts1000: boolean|null = null

	public toRequest(): BrandManagementRequest
	{
		const result = new BrandManagementRequest()
		result.name = this.brand
		result.companyName = this.company
		result.products = this.products

		let minContracts = null
		let maxContracts = null
		if(this.contracts09) {
			minContracts = 0
			maxContracts = 9
		} else if(this.contracts1099) {
			minContracts = 10
			maxContracts = 99
		} else if(this.contracts100999) {
			minContracts = 100
			maxContracts = 999
		} else if(this.contracts1000) {
			minContracts = 1000
			maxContracts = null
		}
		result.minActiveContracts = minContracts
		result.maxActiveContracts = maxContracts

		return result
	}
}

const BrandAdvancedSearchValidation = {
}

export default Yup.object()
	.shape(
		BrandAdvancedSearchValidation,
	)
	.required()
